import { NavLink, Outlet } from 'react-router-dom';
import { Icons } from './Icons.jsx';
import { useAuth } from '../lib/auth.jsx';
import { useI18n, useT } from '../lib/i18n.jsx';
import { initials } from '../lib/format.js';

const NAV = [
  { to: '/', end: true, key: 'overview', icon: 'Home' },
  { to: '/kids', key: 'kids', icon: 'Users' },
  { to: '/subscription', key: 'subscription', icon: 'Crown' },
  { to: '/account', key: 'account', icon: 'Settings' },
];

/** Site root the portal hangs off, so "back to site" works at any mount depth. */
const SITE_URL = import.meta.env.VITE_SITE_URL || '/';

export default function Shell() {
  const t = useT();
  const { lang, setLang } = useI18n();
  const { user, signOut } = useAuth();

  const name = user?.name?.trim();
  const email = user?.email || '';

  return (
    <div className="app">
      <aside className="sidebar">
        <a className="brand" href={SITE_URL}>
          <span className="brand-mark" aria-hidden="true">
            <Icons.Book size={18} />
          </span>
          <span className="brand-text">
            <strong>{t('brand.name')}</strong>
            <small>{t('brand.portal')}</small>
          </span>
        </a>

        <nav className="nav">
          {NAV.map((item) => {
            const Icon = Icons[item.icon];
            return (
              <NavLink
                key={item.key}
                to={item.to}
                end={item.end}
                className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
              >
                <Icon size={18} />
                <span>{t(`nav.${item.key}`)}</span>
              </NavLink>
            );
          })}
        </nav>

        <div className="sidebar-foot">
          <button
            type="button"
            className="lang-toggle"
            onClick={() => setLang(lang === 'ar' ? 'en' : 'ar')}
          >
            <Icons.Globe size={16} />
            <span>{lang === 'ar' ? 'English' : 'العربية'}</span>
          </button>
          <a className="nav-item subtle" href={SITE_URL}>
            <Icons.ChevronL size={18} />
            <span>{t('nav.backToSite')}</span>
          </a>
        </div>
      </aside>

      <div className="main">
        <header className="topbar">
          <div className="who">
            <span className="avatar-initials" aria-hidden="true">{initials(name || email)}</span>
            <span className="who-text">
              <strong>{name || t('overview.greetingNoName')}</strong>
              <small>{email}</small>
            </span>
          </div>
          <button type="button" className="btn ghost" onClick={signOut}>
            <Icons.Logout size={18} />
            <span>{t('nav.signOut')}</span>
          </button>
        </header>

        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
